import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CreateJuzgadoParteRequest } from '@models/juzgadoParte/createJuzgadoParteRequest.model';
import { CreateJuzgadoParteResponse } from '@models/juzgadoParte/createJuzgadoParteResponse.model';
import { JuzgadoParteDto } from '@models/juzgadoParte/juzgadoParteDto.model';
import { UpdateJuzgadoParteRequest } from '@models/juzgadoParte/updateJuzgadoParteRequest.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class JuzgadoParteService {

  constructor(
    private http:HttpClient
  ) { }

  createCollection(createJuzgadoParteRequest:CreateJuzgadoParteRequest[]):Observable<CreateJuzgadoParteResponse>
  {
    return  this.http.post<CreateJuzgadoParteResponse>("/api/JuzgadoParte/CreateCollection",createJuzgadoParteRequest);
  }

  create(createJuzgadoParteRequest:CreateJuzgadoParteRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/JuzgadoParte/Create",createJuzgadoParteRequest);
  }

  update(updateJuzgadoParteRequest:UpdateJuzgadoParteRequest):Observable<any>
  {
    return  this.http.put<any>("/api/JuzgadoParte/Update",updateJuzgadoParteRequest);
  }

  getAll():Observable<JuzgadoParteDto[]> {
    return   this.http.get<JuzgadoParteDto[]>("/api/JuzgadoParte/GetAll");
  }

  getById(id:number):Observable<JuzgadoParteDto>{
    return  this.http.get<JuzgadoParteDto>("/api/JuzgadoParte/GetById?id="+id);
  }

  getAllByIdJuzgado(idJuzgado:number):Observable<JuzgadoParteDto[]>{
    return  this.http.get<JuzgadoParteDto[]>("/api/JuzgadoParte/GetAllByIdJuzgado?idJuzgado="+idJuzgado);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/JuzgadoParte/Delete?id=" + id);
    else
      return of(null)
  }
}
